import { isBossInvulnerable, type GameState } from '@bioforge/game-core';
import type { PublicBoss } from '@bioforge/protocol';

/**
 * Босс локальной партии в том же виде, что присылает сервер: одиночный экран и сетевые
 * рисуют банку и панели босса по одним данным.
 */
export function publicBossOf(state: GameState): PublicBoss | null {
  const config = state.rules.boss;
  const boss = state.boss;
  if (!config || !boss) return null;
  return {
    id: config.id,
    placement: config.placement,
    hp: boss.hp,
    maxHp: config.hp,
    body: config.body,
    abilities: config.abilities.map((spec, i) => ({
      kind: spec.kind,
      name: spec.name,
      countdown: boss.abilities[i]?.countdown ?? null,
      belowHp: spec.belowHp,
      done: boss.abilities[i]?.done ?? false,
      count: spec.count,
      targets: boss.abilities[i]?.targets ?? [],
    })),
    fog: boss.fog,
    storm: boss.storm,
    dormant: boss.dormant,
    invulnerable: isBossInvulnerable(state.board, boss, config),
  };
}
